import React, { useState } from "react";
import { API } from "../../services/api";
import SignedBonPhotoModal from "../../components/SignedBonPhotoModal";
import { LivraisonSuivi } from "./components/LivraisonSuivi";
import { PatientSuivi } from "./components/PatientSuivi";
import { RetraitementConfirmModal } from "./components/RetraitementConfirmModal";
import { SuiviHeader } from "./components/SuiviHeader";
import { usePatientTraitements } from "./hooks/usePatientTraitements";
import { useSuiviFilters } from "./hooks/useSuiviFilters";
import { useSuiviPatients } from "./hooks/useSuiviPatients";

// Écran de suivi : suivi patient (produits suivis, commandes, renvoi en production) et suivi des livraisons effectuées.
export default function SuiviLivraison() {
    const [activeTab, setActiveTab] = useState("patient");
    const [busyId, setBusyId] = useState(null);
    const [photoRow, setPhotoRow] = useState(null);
    const [retraitementTarget, setRetraitementTarget] = useState(null);
    const [livraisonRefreshSignal, setLivraisonRefreshSignal] = useState(0);
    const filters = useSuiviFilters();
    const patients = useSuiviPatients(filters.values, filters.ehpadsLoaded);
    const traitements = usePatientTraitements(patients.grouped, activeTab === "patient");

    const retraiter = async (row) => {
        setRetraitementTarget(null);
        setBusyId(row.id);
        try {
            await API.post(`/medicaments/${row.id}/retraiter`, { destination: row.destination }, { noRedirectOn401: true });
            patients.removeRow(row.id);
            traitements.markRetraited(row.id);
        } catch (e) {
            console.error(e);
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden", background: "white" }}>
            <SuiviHeader
                total={patients.totalElements}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                onRefresh={() => activeTab === "patient" ? patients.refresh() : setLivraisonRefreshSignal(signal => signal + 1)}
                filters={filters}
            />
            {activeTab === "patient" ? (
                <PatientSuivi
                    patients={{
                        grouped: patients.grouped,
                        loading: patients.loading,
                        selectedKey: traitements.selectedKey,
                        loadingMore: patients.loadingMore,
                        hasMore: patients.hasMore,
                        onSelect: traitements.select,
                        onLoadMore: patients.loadMore,
                    }}
                    traitements={{
                        selectedPatient: traitements.selectedPatient,
                        items: traitements.items,
                        loading: traitements.loading,
                        hasMore: traitements.hasMore,
                        onLoadMore: traitements.loadMore,
                    }}
                    busyId={busyId}
                    onRetraiter={setRetraitementTarget}
                    onViewPhoto={setPhotoRow}
                />
            ) : (
                <LivraisonSuivi
                    ehpadId={filters.values.ehpadId}
                    dateLivraison={filters.values.dateReception}
                    refreshSignal={livraisonRefreshSignal}
                    onViewPhoto={setPhotoRow}
                />
            )}
            {retraitementTarget && (
                <RetraitementConfirmModal
                    row={retraitementTarget}
                    onCancel={() => setRetraitementTarget(null)}
                    onConfirm={() => retraiter(retraitementTarget)}
                />
            )}
            {photoRow && (
                <SignedBonPhotoModal
                    historiqueId={photoRow.bonLivraisonHistoriqueId}
                    title={`Bon signé — ${photoRow.ehpadNom || photoRow.ehpadCode}`}
                    photoCount={photoRow.signedBonPhotoCount}
                    onClose={() => setPhotoRow(null)}
                />
            )}
        </div>
    );
}
